(function () {
  // Cartbot injects its cart drawer title as <h1>, creating a duplicate top-level
  // heading on every page. Demote it to <h2> to restore a valid heading outline.
  function demoteCartbotHeading() {
    document.querySelectorAll('h1.dyn-cart-heading-title').forEach(function (h1) {
      var h2 = document.createElement('h2');
      h2.innerHTML = h1.innerHTML;
      for (var i = 0; i < h1.attributes.length; i++) {
        var attr = h1.attributes[i];
        h2.setAttribute(attr.name, attr.value);
      }
      h1.replaceWith(h2);
    });
  }

  // Pandectes GDPR cookie consent renders preference checkboxes (pref_1, pref_2,
  // pref_4, ...) with no <label>, aria-label, or aria-labelledby. Add a name
  // sourced from the nearest visible heading; fall back to common category names.
  var pandectesFallback = {
    pref_1: 'Functional cookies',
    pref_2: 'Analytics cookies',
    pref_3: 'Personalization cookies',
    pref_4: 'Marketing cookies',
  };
  function labelPandectesCheckboxes() {
    var inputs = document.querySelectorAll(
      'input[type="checkbox"][name^="pref_"]'
    );
    var assigned = new Set();
    inputs.forEach(function (cb) {
      var current = cb.getAttribute('aria-label');
      // Re-label if missing OR if it's the shared "Manage consent preferences" string.
      if (current && current !== 'Manage consent preferences' && current.trim() !== '') {
        return;
      }
      // Prefer per-checkbox local text: the row/group container holding this input.
      var row = cb.closest(
        '[class*="row"], [class*="item"], [class*="group"], [class*="purpose"], [class*="category"], li, fieldset'
      );
      var name;
      if (row) {
        // Find a heading or label-like element scoped to this row only.
        var candidate = row.querySelector(
          'legend, h2, h3, h4, h5, h6, [class*="title"], [class*="heading"], [class*="name"], [class*="label"]'
        );
        if (candidate && candidate.textContent.trim()) {
          name = candidate.textContent.trim();
        }
      }
      // Fall back to fixed mapping by name (works even before UI text is in DOM).
      if (!name || assigned.has(name)) {
        name = pandectesFallback[cb.name] || 'Cookie preference (' + cb.name + ')';
      }
      assigned.add(name);
      cb.setAttribute('aria-label', name);
    });
  }

  // Textareas inside admin-managed page content (e.g. /pages/contact) ship with
  // no <label> or aria-label. Use placeholder, nearest preceding label/heading,
  // or a humanized name attribute as a fallback.
  function humanize(s) {
    return s.replace(/[_-]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }).trim();
  }
  function labelOrphanedFields() {
    var fields = document.querySelectorAll(
      'textarea:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="email"]:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="text"]:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="tel"]:not([aria-label]):not([aria-labelledby]), ' +
      'input[type="search"]:not([aria-label]):not([aria-labelledby])'
    );
    fields.forEach(function (f) {
      if (f.id && document.querySelector('label[for="' + f.id + '"]')) return;
      if (f.closest('label')) return;
      var name = (f.placeholder && f.placeholder.trim()) || '';
      if (!name) {
        var prev = f.previousElementSibling;
        while (prev) {
          if (/^(LABEL|H[1-6]|P|SPAN|DIV)$/.test(prev.tagName) && prev.textContent.trim()) {
            name = prev.textContent.trim();
            break;
          }
          prev = prev.previousElementSibling;
        }
      }
      if (!name && f.name) name = humanize(f.name);
      if (name) f.setAttribute('aria-label', name);
    });
  }

  // Flickity carousels are initialized via JS and ship without ARIA. Once
  // Flickity adds the .flickity-enabled class to a wrapper, label it as a
  // carousel and mark the slider track as a live region.
  function addCarouselAria() {
    var SELECTORS = [
      '.flickity-enabled',
      '.cx-flickity-carousel',
      '.slick-slider',
      '.slick-slider-nav',
      '[data-replo-carousel="true"]',
      '[data-flickity]',
      'flickity-carousel',
    ];
    document.querySelectorAll(SELECTORS.join(',')).forEach(function (el) {
      if (el.getAttribute('aria-roledescription') === 'carousel') return;
      el.setAttribute('aria-roledescription', 'carousel');
      if (!el.hasAttribute('aria-label')) {
        var section = el.closest('section, .section, [class*="section-"]');
        var heading = section && section.querySelector('h1, h2, h3, .heading');
        el.setAttribute('aria-label', (heading && heading.textContent.trim()) || 'Carousel');
      }
      var track = el.querySelector(
        '.flickity-viewport .flickity-slider, .flickity-slider, .slick-track, .slick-list'
      );
      if (track && !track.hasAttribute('aria-live')) {
        track.setAttribute('aria-live', 'polite');
      }
    });
  }

  // Cartbot's payment modal close button (.dyn-payment-modal-close-button)
  // renders sitewide with no accessible name. Without it, keyboard/screen
  // reader users cannot dismiss the modal.
  function labelPaymentModalClose() {
    document
      .querySelectorAll('.dyn-payment-modal-close-button:not([aria-label])')
      .forEach(function (btn) {
        btn.setAttribute('aria-label', 'Close payment modal');
        btn.querySelectorAll('svg').forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
        });
      });
  }

  // Respect prefers-reduced-motion: pause autoplaying background videos so
  // motion-sensitive users aren't forced to watch them.
  function pauseAutoplayIfReducedMotion() {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
    });
  }

  // Last-resort focus enforcement: applies the focus ring as inline style on
  // focusin, which beats any third-party stylesheet (Klaviyo, chat widgets)
  // that suppresses focus via !important.
  function enforceFocusRing() {
    var BASE_FOCUS_STYLE =
      'outline: none !important;' +
      'outline-offset: -3px !important;' +
      'z-index: 9999 !important;';
    var INLINE_DISPLAY_FIX = 'display: inline-block !important;';

    function getFocusStyleFor(el) {
      var display = getComputedStyle(el).display;
      if (display === 'inline') {
        return BASE_FOCUS_STYLE + INLINE_DISPLAY_FIX;
      }
      return BASE_FOCUS_STYLE;
    }

    // Defensive: remove the legacy .no-focus-outline class if the theme adds it.
    function purgeNoFocusOutlineClass() {
      if (document.documentElement.classList.contains('no-focus-outline')) {
        document.documentElement.classList.remove('no-focus-outline');
      }
    }
    purgeNoFocusOutlineClass();
    new MutationObserver(purgeNoFocusOutlineClass).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // Apply focus ring on every focusin (no keyboard gate — guarantees visibility
    // for keyboard, programmatic, and audit tooling). Mouse clicks also show it,
    // which is an acceptable tradeoff vs invisible focus.
    document.addEventListener('focusin', function (e) {
      var el = e.target;
      if (!el || el === document.body || el === document.documentElement) return;
      el.dataset.a11yPriorStyle = el.getAttribute('style') || '';
      el.setAttribute('style', (el.dataset.a11yPriorStyle ? el.dataset.a11yPriorStyle + ';' : '') + getFocusStyleFor(el));
    }, true);

    document.addEventListener('focusout', function (e) {
      var el = e.target;
      if (!el || !('a11yPriorStyle' in el.dataset)) return;
      if (el.dataset.a11yPriorStyle) {
        el.setAttribute('style', el.dataset.a11yPriorStyle);
      } else {
        el.removeAttribute('style');
      }
      delete el.dataset.a11yPriorStyle;
    }, true);
  }

  // Imgs missing the alt attribute entirely fail WCAG 1.1.1 even if decorative.
  // Empty alt="" is the correct decorative pattern. This safety net ensures no
  // img has zero alt attribute. Real (meaningful) alt should still come from the
  // Shopify admin / template.
  // Empty links to /pages/shipping-policy ship from admin-edited content
  // without accessible text. Add aria-label safety net.
  // Some Add-to-Cart buttons (e.g. from Replo blocks) ship without aria-label
  // and share the generic "Add to cart" text. Walk up to find the product
  // container and synthesize a contextual label.
  // Remove empty headings — they bloat the heading outline and confuse
  // screen reader navigation (1.3.1).
  function removeEmptyHeadings() {
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (h) {
      if (!h.textContent.trim() && !h.querySelector('img[alt]:not([alt=""])')) {
        h.remove();
      }
    });
  }

  function labelOrphanedATC() {
    var buttons = document.querySelectorAll('button[type="submit"]:not([aria-label])');
    buttons.forEach(function (btn) {
      if (btn.hasAttribute('aria-label') || btn.hasAttribute('aria-labelledby')) return;
      var txt = btn.textContent.trim().toLowerCase();
      if (!/add.*cart/.test(txt)) return;

      // Try several strategies to find a product title.
      var title = '';

      // 1. Closest known product container with a title element inside.
      var ctx = btn.closest('[data-product-id], [data-productid], [data-replo-product-container], [class*="product-item"], [class*="product-card"], [class*="product__"], product-form, [data-product-handle]');
      if (ctx) {
        var titleEl = ctx.querySelector(
          '[class*="product-title"], [class*="product__title"], [class*="product-item-meta__title"], [class*="product-card__title"]'
        );
        if (titleEl) title = titleEl.textContent.trim();
        if (!title && ctx.dataset.productHandle) title = ctx.dataset.productHandle.replace(/-/g, ' ');
      }

      // 2. Walk up DOM looking for nearest heading or product-handle metadata.
      if (!title) {
        var node = btn.parentElement;
        var depth = 0;
        while (node && depth < 10) {
          if (node.dataset && node.dataset.productHandle) {
            title = node.dataset.productHandle.replace(/-/g, ' ');
            break;
          }
          var heading = node.querySelector('h1, h2, h3, h4, [class*="title"]:not([class*="title-bar"])');
          if (heading && heading.textContent.trim().length > 2 && heading.textContent.trim().length < 80) {
            title = heading.textContent.trim();
            break;
          }
          node = node.parentElement;
          depth++;
        }
      }

      btn.setAttribute('aria-label', title ? ('Add ' + title + ' to cart') : 'Add to cart');
    });
  }

  function labelEmptyLinks() {
    document.querySelectorAll('a[href]:not([aria-label])').forEach(function (a) {
      var hasText = a.textContent && a.textContent.trim();
      var hasImg = a.querySelector('img[alt]:not([alt=""])');
      if (hasText || hasImg) return;
      var href = a.getAttribute('href') || '';
      if (/shipping-policy/.test(href)) {
        a.setAttribute('aria-label', 'Shipping policy');
      } else if (/privacy-policy/.test(href)) {
        a.setAttribute('aria-label', 'Privacy policy');
      } else if (/terms/.test(href)) {
        a.setAttribute('aria-label', 'Terms of service');
      } else if (/refund/.test(href)) {
        a.setAttribute('aria-label', 'Refund policy');
      }
    });
  }

  function ensureImgAltAttribute() {
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function runFixes() {
    demoteCartbotHeading();
    labelPandectesCheckboxes();
    labelOrphanedFields();
    addCarouselAria();
    labelPaymentModalClose();
    ensureImgAltAttribute();
    labelOrphanedATC();
    labelEmptyLinks();
    removeEmptyHeadings();
    pauseAutoplayIfReducedMotion();
  }

  enforceFocusRing();
  runFixes();
  new MutationObserver(runFixes).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();



/* FIX FOR THE CART NUMBER NOT UPDATING */
(function () {

  async function updateCartCount() {

    try {

      const response = await fetch('/cart.js');
      const cart = await response.json();

      const count = cart.item_count || 0;

      document.querySelectorAll('.dyn-heading-text-right').forEach(el => {
        el.textContent = `(${count})`;
      });

    } catch (e) {
      console.log('Cart count update failed', e);
    }
  }

  // initial
  updateCartCount();

  // rebuy events
  [
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show',
    'rebuy:smartcart.updated',
    'rebuy:cart.change'
  ].forEach(event => {
    document.addEventListener(event, () => {

      setTimeout(updateCartCount, 50);
      setTimeout(updateCartCount, 200);
      setTimeout(updateCartCount, 500);

    });
  });

  // observe DOM rerenders
  const observer = new MutationObserver(() => {
    updateCartCount();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();